import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
const apiUrl = process.env.REACT_APP_API_BASE_URL;

export const fetchSystemUserAPI = createAsyncThunk(
  "isSystemUser/fetchIsSystemUser",
  async () => {
    const response = await axios.get(
      `${apiUrl}/api/users?limit=1000&isSystemUser=${1}`,
    );
    return response?.data;
  },
);

const systemuserSlice = createSlice({
  name: "isSystemUser",
  initialState: {
    isSysTemUserData: [],
    loading: false,
    error: null,
  },
  reducer: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSystemUserAPI?.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSystemUserAPI?.fulfilled, (state, action) => {
        state.loading = false;
        state.isSysTemUserData = action.payload; // store API response
      })
      .addCase(fetchSystemUserAPI?.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default systemuserSlice?.reducer;
